import { Box } from "@mui/material";

/** Visual marker for required fields/sections (asterisk). */
export default function RequiredMark() {
  return (
    <Box
      component="span"
      aria-hidden
      sx={{ color: "error.main", fontWeight: 700, ml: 0.25 }}
    >
      *
    </Box>
  );
}
